// extracted by mini-css-extract-plugin
module.exports = {"main":"appllication_main__3goC_","copyTBDModal":"appllication_copyTBDModal__33iyy","select":"appllication_select__dCmVM","selects":"appllication_selects__cAHeL"};